<script>
export default {
  name: "ThePageMetadata",
  metaInfo() {
    return {
      title: this.metadata.page_title,
      meta: [
        {name: 'og:site_name', content: this.metadata.page_title},
        {name: 'og:title', content: this.metadata.page_title},
        {name: 'og:description', content: this.metadata.page_description},
        {name: 'og:url', content: this.metadata.page_url},
        {name: 'description', content: this.metadata.page_description},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:description', content: this.metadata.page_description},
        {name: 'twitter:title', content: this.metadata.page_title},
        {name: 'twitter:image', content: this.metadata.main_page_image?.url},
        {name: 'og:locale', content: 'en_US'},
        {name: 'og:type', content: 'website'},
        {name: 'author', content: ''},
        {name: 'robots', content: 'index, follow'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'keywords', content: this.metadata.keywords },
        {'http-equiv': 'X-UA-Compatible', content: 'IE=edge'},
        {'http-equiv': 'Content-Language', content: 'en'},
        {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
        {'http-equiv': 'Cache-Control', content: 'max-age=29030400,public'},
        {property: 'fb:admins', content: ''},
        {property: 'article:publisher', content: 'https://www.facebook.com/*'},
      ],
      link: [
        {rel: 'canonical', href: this.metadata.page_url},
        {rel: 'publisher', href: '*'},
        {rel: 'icon', href: '/favicon.ico'},
      ]
    }
  },
  props: {
    metadata: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
</template>
